import { SUPPORT_WHATSAPP_LINK } from "@/common/constants";
import { displayModeShowsProducts } from "@/common/fields/display-modes";

const EDITOR_PATH = "/app/customization/editor";

// Lo mínimo para que un catálogo recién creado no quede vacío; WhatsApp,
// redes y lo demás son opcionales. `catalog` es la respuesta de /bo/catalog
// con `products` (ver CatalogPreviewCard). Depende del modo: en
// `feed`/`segments` se pide un enlace, y donde hay productos
// (`catalog`/`mix`) un producto en vez del enlace.
export function catalogTasks(catalog) {
    const contentTask = displayModeShowsProducts(catalog.displayMode)
        ? {
              key: "products",
              title: "Sube tu primer producto",
              nudge: "subir tus productos",
              path: "/app/products/new",
              done: (catalog.products || []).length > 0
          }
        : {
              key: "links",
              title: "Agrega un enlace (ubicación, agenda, reseñas)",
              nudge: "agregar enlaces a tu catálogo",
              path: EDITOR_PATH,
              done: (catalog.segments || []).some(
                  (segment) =>
                      segment.type === "links" && (segment.links || []).length
              )
          };
    return [
        contentTask,
        {
            key: "logo",
            title: "Sube tu logo o foto de perfil",
            nudge: "subir tu logo o foto de perfil",
            path: EDITOR_PATH,
            done: Boolean(catalog.logoIconUrl || catalog.logoHorizontalUrl)
        },
        {
            key: "description",
            title: "Escribe la descripción de tu negocio",
            nudge: "escribir la descripción de tu negocio",
            path: EDITOR_PATH,
            done: Boolean((catalog.businessDescription || "").trim())
        }
    ];
}

// Mensaje de la burbuja de soporte al terminar el onboarding: reconoce lo
// que ya hizo y sugiere lo primero que le falta.
export function supportBubbleMessage(catalog) {
    const tasks = catalogTasks(catalog);
    const pending = tasks.find((task) => !task.done);
    if (!pending) {
        return "¡Tu catálogo quedó completo! ¿Tienes dudas para configurarlo? Escríbenos y te ayudamos.";
    }
    const productsCount = (catalog.products || []).length;
    let achievement = "Tu catálogo ya está en línea.";
    if (productsCount === 1) {
        achievement = "Ya subiste 1 producto.";
    } else if (productsCount > 1) {
        achievement = `Ya subiste ${productsCount} productos.`;
    }
    return `${achievement} También puedes ${pending.nudge}. Si quieres que te ayudemos, escríbenos.`;
}

export function supportWhatsappLink(catalogUrl) {
    const text = catalogUrl
        ? `Hola, acabo de crear mi catálogo (${catalogUrl}) y quiero ayuda para configurarlo.`
        : "Hola, acabo de crear mi catálogo y quiero ayuda para configurarlo.";
    return `${SUPPORT_WHATSAPP_LINK}?text=${encodeURIComponent(text)}`;
}
